import Vue from "vue";

import axios from "axios";
import {
  Loading,
  Message
} from "element-ui";
import Qs from "qs";

import codeType from "./codeType";
import router from './router';
//设置全局axios默认值
axios.defaults.timeout = 180000; //20000的超时验证
axios.defaults.withCredentials = false; //跨域不带凭证
axios.defaults.headers['X-Requested-With'] = "XMLHttpRequest";



function http(type, url, params, contentType) {
  // if(localStorage["token"])
  if (sessionStorage["token"]) { 
    axios.defaults.headers['Authorization'] = sessionStorage["token"];
  }else{
    axios.defaults.headers['Authorization'] = ''
  }
  const loadingRes = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  let contentTypeUse = contentType === 'json' ? 'application/json' : 'application/x-www-form-urlencoded';
  let paramsUse = contentType === 'json' ? params : Qs.stringify(params);
  let userData = {};
  let requestParams = {
    method: type,
    headers: type === 'get' ? userData : Object.assign({}, {
      'Content-Type': contentTypeUse
    }, userData),
    url,
    [type === 'get' ? 'params' : 'data']: type === 'get' ? params : paramsUse
  };

  for (let key in requestParams) {
    if (key === '' || !requestParams[key]) {
      Reflect.deleteProperty(requestParams, key)
    }
  }

  return new Promise((resolve, reject) => {
    axios(requestParams).then((res) => {
      loadingRes.close();
      res.data.code = res.data.code || res.data.status;
      codeType(res.data.code, res.data.msg).then(() => {
        // if (res.headers.authorization) {
        //   localStorage.setItem("token", res.headers.authorization)
        // }
        resolve(res.data);
      });
    }).catch((err) => {
      loadingRes.close();
      Message({
        message: '数据异常，请稍后重试!',
        type: 'error',
      });
      reject(err)
    })
  })
}

export default http;


export function formDataHttp(type, url, params) {
  if (localStorage["token"]) {
    if (localStorage["is_use"] != 1) {
      localStorage.removeItem("token");
      router.push({
        path: '/login'
      });
      return false;
    }
    axios.defaults.headers['Authorization'] = localStorage["token"];
  }
  const loadingRes = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  let userData = {};

  let requestParams = {
    method: type,
    headers: type === "get" ?
      userData : Object.assign({}, {
          "Content-Type": "multipart/form-data"
        },
        userData
      ),
    url,
    [type === "get" ? "params" : "data"]: type === "get" ? params : params
  };

  for (let key in requestParams) {
    if (key === "" || !requestParams[key]) {
      Reflect.deleteProperty(requestParams, key);
    }
  }

  return new Promise((resolve, reject) => {
    axios(requestParams).then((res) => {
      loadingRes.close();
      res.data.code = res.data.code || res.data.status;
      codeType(res.data.code, res.data.message).then(() => {
        // if (res.headers.authorization) {
        //   localStorage.setItem("token", res.headers.authorization)
        // }
        resolve(res.data);
      });
    }).catch((err) => {
      loadingRes.close();
      Message({
        message: '数据异常，请稍后重试!',
        type: 'error',
      });
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/axios.js